import React from "react"
import { STYLES } from "./_styles"

interface HeaderProps {
  title?: string
  subtitle?: string
  children?: React.ReactNode
}

const Header: React.FC<HeaderProps> = ({ title, subtitle, children }) => {
  const displayTitleOrSubtitle = !!title || !!subtitle
  const displayHeader = displayTitleOrSubtitle || !!children

  return (
    <>
      <div className={STYLES.accentBar} style={{ backgroundColor: "#2596fa" }} />
      {displayHeader && (
        <div className={STYLES.header} data-testid="public-reservation-modal-header-container">
          <div className={STYLES.headerInner}>
            {displayTitleOrSubtitle && (
              <div className={STYLES.headerLeft}>
                {!!title && (
                  <h2 className={STYLES.title} data-testid="public-reservation-modal-header-title">
                    {title}
                  </h2>
                )}
                {!!subtitle && (
                  <p className={STYLES.subtitle} data-testid="public-reservation-modal-header-subtitle">
                    {subtitle}
                  </p>
                )}
              </div>
            )}
            {children && <div className={STYLES.headerRight}>{children}</div>}
          </div>
        </div>
      )}
    </>
  )
}

export default Header
